@if (promoBlockData) {
  <div
    class="bg-white flex flex-col justify-center w-full items-center px-8 py-16 lg:py-20"
  >
    <div
      class="mb-6 lg:px-32 w-full"
      [ssDirectus]="{
        collection: 'promoBlock',
        item: promoBlockData.id,
        fields: ['promoImage'],
      }"
    >
      <ss-www-image-with-loader
        class="w-full aspect-[2/1] md:aspect-[16/7] rounded-2xl"
        [fileDetail]="promoBlockData.promoImage"
        desktopImageSize="2/3rds"
      ></ss-www-image-with-loader>
    </div>
    <div
      [innerHTML]="promoBlockData?.promoText"
      class="text-lg text-center text-ss-brown lg:text-2xl lg:mx-56"
      [ssDirectus]="{
        collection: 'promoBlock',
        item: promoBlockData.id,
        fields: ['promoText'],
      }"
    ></div>
    @if (promoBlockData.promoButtonUrl?.startsWith('/')) {
      <a
        [routerLink]="[promoBlockData.promoButtonUrl]"
        class="no-underline"
        [ssDirectus]="{
          collection: 'promoBlock',
          item: promoBlockData.id,
          fields: [
            'promoButtonText',
            'promoButtonUrl',
            'promoButtonColor',
            'promoButtonStyle',
          ],
        }"
      >
        <ng-container *ngTemplateOutlet="promoButton"></ng-container>
      </a>
    } @else {
      <a
        [href]="promoBlockData.promoButtonUrl"
        class="no-underline"
        [ssDirectus]="{
          collection: 'promoBlock',
          item: promoBlockData.id,
          fields: [
            'promoButtonText',
            'promoButtonUrl',
            'promoButtonColor',
            'promoButtonStyle',
          ],
        }"
      >
        <ng-container *ngTemplateOutlet="promoButton"></ng-container>
      </a>
    }
    <ng-template #promoButton>
      @if (promoBlockData.promoButtonText) {
        <ss-button
          class="w-full mt-4 lg:px-inherit lg:max-w-[147px]"
          [buttonColor]="promoBlockData.promoButtonColor"
          [buttonStyle]="promoBlockData.promoButtonStyle"
          >{{ promoBlockData.promoButtonText }}</ss-button
        >
      }
    </ng-template>
  </div>
}
